import script from "./RewardMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./RewardMobile.vue?vue&type=script&setup=true&lang=js"

import "./RewardMobile.vue?vue&type=style&index=0&id=618ee440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-618ee440"]])

export default __exports__